import { useValidateCompanyDetailsPt1 } from 'app/core/api/company/api-company';
import { CompanyDetailsPt1 } from 'app/core/api/company/api-company.types';
import FormTextInput from 'app/shared/components/form-input/FormTextInput';
import useInputForm from 'app/shared/components/form-input/utilities/use-input-form';
import { ErrorText } from 'app/shared/components/misc';
import Body from 'app/shared/components/typography/body/Body';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import Form from 'app/shared/frames/Form';
import React from 'react';
import { tap } from 'rxjs/operators';
import {
  patchBusinessProfileTemp,
  useGetBusinessProfileTempOnce,
  useMovePage,
} from '../business-profile-utils';
import BottomPageAndSubmitActions from './components/BottomActions';

type FormValues = CompanyDetailsPt1;

export default function ProfileP3CompanyDetailsPt1(): JSX.Element {
  useSetPageTitle('Company Details');

  const { nextPage } = useMovePage();

  const { request$, error, sending } = useValidateCompanyDetailsPt1();
  const defaultValues = useGetBusinessProfileTempOnce();

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { handleSubmit, getValues, inputProps } =
    useInputForm<FormValues>({
      mode: 'onTouched',
      defaultValues,
      apiError: error,
    });

  return (
    <>
      <Body color="primary" style={{ fontWeight: 'normal' }}>
        Enter your company details
      </Body>
      <Form
        flexStretch
        onSubmit={handleSubmit(details => {
          patchBusinessProfileTemp(details);
          return request$(details).pipe(tap(() => nextPage()));
        })}
      >
        <FormTextInput
          controlName="name"
          placeholder="Legal name of business"
          autoComplete="organization"
          {...inputProps}
        />
        <FormTextInput
          controlName="displayName"
          placeholder="Name to appear to consumers"
          autoComplete="organization"
          optional
          {...inputProps}
        />
        <FormTextInput
          controlName="companyNumber"
          autoComplete="organization-name"
          optional
          {...inputProps}
        />
        <FormTextInput
          controlName="vatNumber"
          placeholder="VAT number"
          optional
          {...inputProps}
        />
        <FormTextInput
          controlName="phone"
          placeholder="Business phone number"
          autoComplete="tel"
          optional
          type="tel"
          {...inputProps}
        />
        <FormTextInput
          controlName="website"
          autoComplete="url"
          inputProps={{ inputMode: 'url' }}
          optional
          {...inputProps}
        />
        <Body tiny>Asterisks (*) indicate required fields</Body>
        <ErrorText message={error} />
        <BottomPageAndSubmitActions
          onBack={() => patchBusinessProfileTemp(getValues())}
          {...{ sending }}
        />
      </Form>
    </>
  );
}
